import RootLayout from "../../components/layout/RootLayout";
import Hero from "./Hero";

const Pricing = () => {
  return (
    <RootLayout>
      <main>
        <Hero />
      </main>
    </RootLayout>
  );
};

export default Pricing;
